export class ChangePassModel {

    senhaAntiga : string = "";
    senhaNova : string = "";
    
}
